<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="Comment content" prop="content">
                <a-input v-model="queryParam.content" :maxLength="32" :placeholder="$t('请输入')+'Comment content'" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="Product Name" prop="goodsName">
                <a-input v-model="queryParam.goodsName" :maxLength="32" :placeholder="$t('请输入')+'Product Name'" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="Username" prop="userNick">
                  <a-input v-model="queryParam.userNick" :maxLength="32" :placeholder="$t('请输入')+'Username'" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createBeginTime"
                    :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker
                    style="width: 100%"
                    v-model="queryParam.createEndTime"
                    :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-row :gutter="16" class="review-statistics">
        <a-col :md="6" :sm="12"><a-card><a-statistic title="Total Reviews" :value="statistics.totalCount" /></a-card></a-col>
        <a-col :md="6" :sm="12"><a-card><a-statistic title="Positive Reviews" :value="statistics.goodCount" /></a-card></a-col>
        <a-col :md="6" :sm="12"><a-card><a-statistic title="Neutral Reviews" :value="statistics.mediumCount" /></a-card></a-col>
        <a-col :md="6" :sm="12"><a-card><a-statistic title="Negative Reviews" :value="statistics.badCount" /></a-card></a-col>
      </a-row>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:review:add']">-->
        <!--          <a-icon type="plus" />-->
        <!--          {{ $t('新增') }}-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['order:review:edit']">-->
        <!--          <a-icon type="edit" />-->
        <!--          {{ $t('修改') }}-->
        <!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:review:remove']">
          <a-icon type="delete" />
          {{ $t('删除') }}
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['order:review:export']">-->
        <!--          <a-icon type="download" />-->
        <!--          {{ $t('导出') }}-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <reply-form ref="replyForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="repliedAt" slot-scope="text, record">
          {{ parseTime(record.repliedAt) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <div slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" disabled></a-switch>
          {{ record.status === 0 ? $t('关闭') : $t('开启') }}
        </div>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.replyForm.handleReply(record)" v-hasPermi="['order:review:edit']">
            <a-icon type="message" />{{ record.isReplied ? 'Edit Reply' : 'Reply' }}
          </a>
          <a-divider type="vertical" v-hasPermi="['order:review:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:review:edit']">
            <a-icon type="edit" />{{ $t('修改') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['order:review:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:review:remove']">
            <a-icon type="delete" />{{ $t('删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageReview, statisticsReview, delReview } from '@/api/order/review'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import ReplyForm from './modules/ReplyForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Review',
  components: {
    CustomDictTag,
    CreateForm,
    ReplyForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      statistics: {
        totalCount: 0,
        goodCount: 0,
        mediumCount: 0,
        badCount: 0
      },
      // 租户ID，外键{tenant.id}时间范围
      daterangeRepliedAt: [],
      // 查询参数
      queryParam: {
        orderId: undefined,
        orderItemId: undefined,
        goodsId: undefined,
        skuId: undefined,
        userId: undefined,
        orderNo: undefined,
        goodsName: undefined,
        userNick: undefined,
        content: undefined,
        isAnonymous: undefined,
        isReplied: undefined,
        isTop: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Comment content',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center',
          fixed: 'left'
        },
        {
          title: 'Star',
          dataIndex: 'star',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Picture',
          dataIndex: 'imagesJson',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Product Name',
          dataIndex: 'goodsName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Username',
          dataIndex: 'userNick',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Order No',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Reply',
          dataIndex: 'replyContent',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Is replied',
          dataIndex: 'isReplied',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Anonymous',
          dataIndex: 'isAnonymous',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Create time',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Status',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '220px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询评价管理列表 */
    getList() {
      this.loading = true
      this.queryParam.params = {}
      if (this.daterangeRepliedAt !== null && this.daterangeRepliedAt !== '' && this.daterangeRepliedAt.length !== 0) {
        this.queryParam.params['beginRepliedAt'] = this.daterangeRepliedAt[0]
        this.queryParam.params['endRepliedAt'] = this.daterangeRepliedAt[1]
      }
      Promise.all([pageReview(this.queryParam), statisticsReview(this.queryParam)]).then(([pageResponse, statisticsResponse]) => {
        this.list = pageResponse.data.records
        this.total = pageResponse.data.total
        this.statistics = statisticsResponse.data
      }).finally(() => {
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.daterangeRepliedAt = []
      this.queryParam = {
        orderId: undefined,
        orderItemId: undefined,
        goodsId: undefined,
        skuId: undefined,
        userId: undefined,
        orderNo: undefined,
        goodsName: undefined,
        userNick: undefined,
        content: undefined,
        isAnonymous: undefined,
        isReplied: undefined,
        isTop: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delReview(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('order/review/export',
            that.queryParam
            , `${that.$t('评价管理')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
